
import EDTextSelect from '../../../../../../../BaseComponents/Selects/TextSelect/EDTextSelect';
import { ISelectChoice } from '../../../../../../../BaseComponents/Selects/SelectCommons';

interface IProps {
  denomination: number;
  onChange: (denomination: number) => void;
}

export const Denominations: Array<ISelectChoice<number>> = [
  {
    header: 'kr',
    subHeader: 'kronor',
    value: 1,
  },
  {
    header: 'tkr',
    subHeader: 'tusentals kronor',
    value: 1000,
  },
  {
    header: 'mnkr',
    subHeader: 'miljontals kronor',
    value: 1000000,
  },
];

/**
 * Värde visning och val av valör för en analys.
 */
const EkonomiskAnalysDenominations = (props: IProps) => {
  return (
    <EDTextSelect<number>
      label="Enhet"
      labelTooltip="Välj enhet"
      labelColor="textPrimary"
      onChange={props.onChange}
      items={Denominations}
      currentValue={props.denomination}
    />
  );
};

export default EkonomiskAnalysDenominations;
